import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SignInFlowComponent } from '@auth-n/sign-in-flow/sign-in-flow.component';
import { AuthLayoutComponent } from '@app/app-layout/auth-n/layout/auth-layout.component';
import { DomainMigrationNoticeComponent } from '@app/domain-migration/domain-migration-notice/domain-migration-notice.component';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SignInFlowComponent, AuthLayoutComponent, DomainMigrationNoticeComponent]
})
export class SignInComponent {}
